<template>
  <div class="page-layout" :class="{ 'has-footer': hasFooter }">

    <!-- Page Header (Full Width) -->
    <div v-if="$slots.header" class="page-header">
      <slot name="header">
        <!-- Header content goes here -->
      </slot>
    </div>

    <!-- Content Container -->
    <div class="page-content">
      <!-- Main Content Area -->
      <div class="page-main">
        <slot name="main">
          <!-- Main content goes here -->
        </slot>
      </div>

      <!-- Divider -->
      <div v-if="$slots.sidebar" class="page-divider"></div>

      <!-- Sidebar -->
      <slot v-if="$slots.sidebar" name="sidebar">
        <!-- Sidebar component goes here -->
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',

  props: {
    hasFooter: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.page-layout {
  display: flex;
  flex-direction: column;
  max-width: 2048px !important;
  margin-inline: auto;
  flex: 1;
  min-height: calc(100vh - 4rem);

  // Wenn Footer vorhanden ist, füge padding hinzu
  &.has-footer {
    padding-bottom: 80px;
  }
}

.page-header {
  border-bottom: 1px solid var(--bs-border-color);
}

.page-main {
  flex: auto;
}
.page-header, .page-main {
  padding: 1.5rem;
  @media (min-width: 992px) {
    padding: 2rem;
    max-width: calc(100% - 0px);
  }
  @media (min-width: 1280px) {
    padding: 2rem 3rem;
    max-width: calc(100% - 0px);
  }
}

.page-content {
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (min-width: 992px) {
    flex-direction: row;
  }
}

.page-divider {
  display: none;
  width: 1px;
  background-color: var(--bs-border-color);

  @media (min-width: 992px) {
    display: block;
  }
}
</style>
